<p-dialog
  header="Data Privacy Notice"
  styleClass="data-privacy-dialog"
  [visible]="show()"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  (visibleChange)="onVisibleChange()"
>
  <span
    >Confidential information will only be shared with and used by the specified users for the intended purposes and
    will not be disclosed to external parties. We are committed to protecting your privacy and ensuring your data is
    handled securely and in compliance with applicable regulations.</span
  >

  <ng-template #footer>
    <div class="d-flex justify-content-between gap-2 w-100">
      <p-button
        type="button"
        label="No, I don't agree"
        [outlined]="true"
        (onClick)="onConfirmDataPrivacy(false)"
      ></p-button>
      <p-button type="button" label="Yes, I agree" (onClick)="onConfirmDataPrivacy(true)"></p-button>
    </div>
  </ng-template>
</p-dialog>
